// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32qHG","name":"Header_name__2DzMY","birthday":"Header_birthday__3V4wy","skeleton":"Header_skeleton__28eNh"};